import { Component, OnInit, TemplateRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { UserService } from "../../../../services/userService/user.service";
import { RolePermissionServiceService } from "../../../../services/rolepermission/role-permission-service.service";
import { RolePermissionService } from "../../../../appService/role-permission.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-inquirydocument",
  templateUrl: "./inquirydocument.component.html",
  styleUrls: ["./inquirydocument.component.css"],
})
export class InquirydocumentComponent implements OnInit {
  userid: any;
  btnLoader: boolean = false;
  InquiryId: number = 0;
  id: any;
  IqrNum: any;
  isMediabtnClicked: boolean;
  mediaUploadDisplay: boolean;
  totalMediaSize: any;
  totalMediaLength: number;
  modalRef: BsModalRef;
  config: {
    class: "modal-dialog-centered";
    backdrop: "static";
    ignoreBackdropClick: true;
    keyboard: false;
  };
  upload_disable: boolean;
  preview: string;
  fileUpload: any[];
  imgURL: any[];
  mediaPostTextTemp: string;
  mediaPostLoader: boolean;
  mediaPostArr: {};
  allowDragover: boolean;
  postTextWithLink: string;
  sharePostArr: {};
  urlMediaTitle: any;
  urlTitle: any;
  urlMediaDescription: any;
  urlDescription: any;
  urlMediaImage: any;
  urlImage: any;
  urlMediaLink: any;
  urlLink: any;
  iframe: any;
  isPrivacySettingsMediaPostBtnEnable: boolean;
  fileUploadCount: number;
  postMediaGreaterThanCheckError: string;
  file_upload_loader: boolean;
  videoURL: any[];
  isImagePasted: boolean;
  pasteEvnetStatus: boolean;
  fileUploadLoader: boolean;
  clicked: boolean;
  dft_icn: string;
  url: string;
  downloadurl: string;
  inqId: any;
  filename: any;
  file: any;
  delNameDel: boolean;
  inquirydata: any;
  permission: any;
  inquirydoc: any;
  isCollapsed: boolean;
  type: any;
  active: string;
  base64Image1: string;

  constructor(
    private route: ActivatedRoute,
    private UserService: UserService,
    private service: RolePermissionService,
    private roleservice: RolePermissionServiceService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private http: HttpClient
  ) {
    this.active = localStorage.getItem("active_id");
    let decid = localStorage.getItem("editiqrid");
    decid = decid
      .toString()
      .replace("Ar1t", "=")
      .replace("FGH", "/")
      .replace("THD", "+");
    this.id = this.UserService.decryptData(decid);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
  }

  ngOnInit(): void {
    this.url = environment.tempimage;
    this.downloadurl = environment.app_download_path;
    this.dft_icn = environment.default_temp;
    this.getInquiryDetails();
  }

  getInquiryDetails() {
    let data = {
      InquiryId: this.id,
      Mode: "Edit",
    };
    this.spinner.show();
    this.UserService.GetInquiryDetailById(data).subscribe((res) => {
      this.IqrNum = res["Data"]["InquiryNumber"];
      this.InquiryId = res["Data"]["InquiryId"];
      this.inquirydoc = res["UploadDocument"];
      this.inquirydata = res["Data"];
      this.spinner.hide();
    });
  }

  openModal(template: TemplateRef<any>, type: any) {
    this.type = type;
    this.isMediabtnClicked = false;
    this.mediaUploadDisplay = true;
    this.totalMediaSize = 0;
    this.totalMediaLength = 0;
    this.modalRef = this.modalService.show(template, {
      class: "modal-dialog-centered",
      backdrop: "static",
      ignoreBackdropClick: true,
      keyboard: false,
    });
    this.upload_disable = true;
    this.preview = "";
    this.fileUpload = [];
    this.imgURL = [];
    this.mediaPostTextTemp = "";
    this.mediaPostLoader = true;
    this.mediaPostArr = {};
    this.allowDragover = false; //to close the drag box
    //Add Post show url details letiables(n)
    this.postTextWithLink = "";
    this.sharePostArr = {};
    this.urlMediaTitle = this.urlTitle;
    this.urlMediaDescription = this.urlDescription;
    this.urlMediaImage = this.urlImage;
    this.urlMediaLink = this.urlLink;
    this.urlMediaImage = this.iframe;
    this.isPrivacySettingsMediaPostBtnEnable = false;
    this.urlTitle = "";
    this.urlDescription = "";
    this.urlImage = "";
    this.urlLink = "";
    this.iframe = "";
    //End Add Post show url details letiables(n)
    this.fileUploadCount = 0;

    // Show the error massege while the post file size is grater than 20 mb.(D)
    this.postMediaGreaterThanCheckError = "";

    //End Post Text With media upload letiable(a)
  }

  closeModalFileUplaodFalse() {
    this.file_upload_loader = false;
    this.imgURL = [];
    this.videoURL = [];
    this.fileUpload = [];
    this.isImagePasted = false;
    this.pasteEvnetStatus = true;
    this.fileUploadCount = 0;
  }

  fileChangeEvent(event: any) {
    let file_array = [];
    let upload_fileIcon = environment.upload_image_url;
    this.allowDragover = false;
    if (event?.target?.files) {
      file_array = event.target.files;
      this.totalMediaLength += file_array.length;
      if (this.totalMediaLength <= 1) {
        let x = 0;

        while (x < file_array.length) {
          let fileDetails = file_array[x];

          this.totalMediaSize += fileDetails.size;

          if (this.totalMediaSize <= 36700160) {
            if (
              fileDetails.type == "image/png" ||
              fileDetails.type == "image/jpeg" ||
              fileDetails.type == "image/webp" ||
              fileDetails.type == "image/gif" ||
              fileDetails.type == "image/x-icon" ||
              fileDetails.type == "image/bmp"
            ) {
              this.file_upload_loader = true;
              let $this_func = this;
              let getCustomerSyncFlag = function (callback) {
                $this_func.setupReader(fileDetails, x, file_array.length);
                let SyncFlag = x + 1;
                callback(null, SyncFlag);
              };

              getCustomerSyncFlag(function (err, SyncFlag) {
                x = SyncFlag;
              });
            } else if (
              fileDetails.type == "video/mp4" ||
              fileDetails.type == "video/webm" ||
              fileDetails.type == "video/ogg" ||
              fileDetails.type == "video/quicktime"
            ) {
              this.file_upload_loader = true;
              let $this_func = this;
              let getCustomerSyncFlag = function (callback) {
                $this_func.setupReader(fileDetails, x, file_array.length);
                let SyncFlag = x + 1;
                callback(null, SyncFlag);
              };

              getCustomerSyncFlag(function (err, SyncFlag) {
                x = SyncFlag;
              });
            } else if (
              fileDetails.type == "audio/ogg" ||
              fileDetails.type == "audio/mpeg" ||
              fileDetails.type == "audio/vnd.dlna.adts"
            ) {
              this.file_upload_loader = true;
              let $this_func = this;
              let getCustomerSyncFlag = function (callback) {
                if (fileDetails.type.includes("audio/")) {
                  switch (fileDetails.type) {
                    case "audio/ogg":
                      $this_func.imgURL.push({
                        url: upload_fileIcon + "file_icons/ogg.png",
                        size: fileDetails.size,
                        type: "image",
                        name: fileDetails.name,
                      });
                      break;

                    case "audio/mpeg":
                      $this_func.imgURL.push({
                        url: upload_fileIcon + "file_icons/mp3.png",
                        size: fileDetails.size,
                        type: "image",
                        name: fileDetails.name,
                      });
                      break;

                    case "audio/vnd.dlna.adts":
                      $this_func.imgURL.push({
                        url: upload_fileIcon + "file_icons/aac.png",
                        size: fileDetails.size,
                        type: "image",
                        name: fileDetails.name,
                      });
                      break;

                    default:
                      $this_func.imgURL.push({
                        url: upload_fileIcon + "format/audio.webp",
                        size: fileDetails.size,
                        type: "image",
                        name: fileDetails.name,
                      });
                      break;
                  }
                }
                $this_func.fileUpload.push(fileDetails);
                $this_func.fileUploadCount = $this_func.fileUpload.length;
                let SyncFlag = x + 1;
                callback(null, SyncFlag);
              };

              getCustomerSyncFlag(function (err, SyncFlag) {
                x = SyncFlag;
                if (x == file_array.length) {
                  $this_func.file_upload_loader = false;
                }
              });
            } else if (
              fileDetails.type == "application/vnd.ms-excel" ||
              fileDetails.type == "application/msword" ||
              fileDetails.type ==
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
              fileDetails.type ==
                "application/vnd.oasis.opendocument.spreadsheet" ||
              fileDetails.type ==
                "application/vnd.oasis.opendocument.spreadsheet" ||
              fileDetails.type == "application/pdf" ||
              fileDetails.type == "text/csv" ||
              fileDetails.type == "message/rfc822" ||
              fileDetails.type ==
                "application/vnd.ms-powerpointapplication/vnd.ms-powerpoint" ||
              fileDetails.type ==
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
              fileDetails.type ==
                "application/vnd.ms-word.document.macroEnabled.12" ||
              fileDetails.type == "text/plain" ||
              fileDetails.type == "application/vnd.ms-powerpoint" ||
              fileDetails.type == "application/zip" ||
              fileDetails.type == "application/octet-stream" ||
              fileDetails.type == "application/x-zip-compressed" ||
              fileDetails.type == "multipart/x-zip" ||
              fileDetails.type == "application/vnd.rar" ||
              fileDetails.type == "application/x-rar-compressed" ||
              (fileDetails.type == "" && fileDetails.name.slice(-4) == ".rar")
            ) {
              this.file_upload_loader = true;
              let $this_func = this;
              let getCustomerSyncFlag = function (callback) {
                switch (fileDetails.type) {
                  case "application/vnd.ms-excel":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/csv.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/excel.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.oasis.opendocument.spreadsheet":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/excel.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/pdf":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/pdf.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.ms-powerpointapplication/vnd.ms-powerpoint":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/ppt.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/word.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/msword":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/word.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.ms-word.document.macroEnabled.12":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/word.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "text/plain":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/txt.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  case "application/vnd.ms-powerpoint":
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/ppt.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;

                  default:
                    $this_func.imgURL.push({
                      url: upload_fileIcon + "file_icons/file.png",
                      size: fileDetails.size,
                      type: "image",
                      name: fileDetails.name,
                    });
                    break;
                }
                $this_func.fileUpload.push(fileDetails);
                $this_func.fileUploadCount = $this_func.fileUpload.length;
                let SyncFlag = x + 1;
                callback(null, SyncFlag);
              };

              getCustomerSyncFlag(function (err, SyncFlag) {
                x = SyncFlag;
                if (x == file_array.length) {
                  $this_func.file_upload_loader = false;
                }
              });
            } else {
              this.totalMediaSize -= fileDetails.size;
              this.totalMediaLength = this.totalMediaLength - 1;
              if (x + 1 == file_array.length) {
                this.file_upload_loader = false;
              }
              if (fileDetails.type.includes("image/")) {
                this.toastr.error(
                  "Images can't be uploaded. Only jpg, jpeg, png, webp, ico, bmp and gif files are allowed!",
                  "Error!"
                );
              } else if (fileDetails.type.includes("video/")) {
                this.toastr.error(
                  "Video can't be uploaded. Only MP4, Mov webm and ogg files are allowed!",
                  "Error!"
                );
              } else if (fileDetails.type.includes("audio/")) {
                this.toastr.error(
                  "Audio can't be uploaded. Only mp3, aac and ogg files are allowed!",
                  "Error!"
                );
              } else if (
                fileDetails.type.includes("application/") ||
                fileDetails.type.includes("text/")
              ) {
                this.toastr.error(
                  "File can't be uploaded. Only CSV,XLS,XLSX,DOC,DOCX,DOCM,PDF,TXT,PPT,ZIP files are allowed!",
                  "Error!"
                );
              } else if (fileDetails.type == "" || fileDetails.type == null) {
                this.toastr.error("File can't supported", "Error!");
              } else {
                this.toastr.error(
                  "File can't be uploaded. Only Image, Audio, Video and Doc files are allowed!",
                  "Error!"
                );
              }
              x++;
            }
          } else {
            this.totalMediaSize -= fileDetails.size;
            this.toastr.error(
              "File can't be uploaded. Total File size should be smaller than 35 MB.",
              "Error!"
            );
            if (x + 1 == file_array.length) {
              this.file_upload_loader = false;
            }
            this.totalMediaLength = 0;
            x++;
          }
        }
      } else {
        this.totalMediaLength -= file_array.length;
        this.toastr.error(
          "Unable to upload more than 1 file at a time.",
          "Error!"
        );
      }
    } else {
      this.toastr.error(
        "File can't be uploaded. Only Image, Audio, Video and Doc files are allowed!",
        "Error!"
      );
    }
  }
  //End Calling the change event whent the media is selected in the local file (n) edid (D)

  RemoveImage(data, key) {
    this.totalMediaSize = +this.totalMediaSize - +data.size;
    this.totalMediaLength = this.totalMediaLength - 1;
    this.pasteEvnetStatus = true;
    this.imgURL.splice(key, 1);
    this.fileUpload.splice(key, 1);
    this.fileUploadCount = 0;
    this.file_upload_loader = false;
    this.postMediaGreaterThanCheckError = "";
    this.allowDragover = false;
  }
  //End  Onclick the remove tage remove the current image(D)

  //Setup Reader method for converting img into base64 for preview(D)
  setupReader(file, num, file_length) {
    let upload_fileIcon = environment.upload_image_url;
    try {
      let fileReader = new FileReader();

      let $this = this;
      if (file.type.match("image")) {
        if (file.size < "20971520") {
          fileReader.onload = function () {
            $this.imgURL.push({
              url: fileReader.result,
              size: file.size,
              type: "image",
              name: file.name,
            });
            $this.fileUpload.push(file);
            $this.fileUploadCount = $this.fileUpload.length;
            if (num + 1 == file_length) {
              $this.file_upload_loader = false;
            }
            $this.pasteEvnetStatus = true;
          };
          fileReader.readAsDataURL(file);
        } else {
          $this.imgURL.push({
            url: upload_fileIcon + "image_preview.jpg",
            size: file.size,
            type: "image",
            name: file.name,
          });
          $this.fileUpload.push(file);
          $this.fileUploadCount = $this.fileUpload.length;

          if (num + 1 == file_length) {
            $this.file_upload_loader = false;
          }
          $this.pasteEvnetStatus = true;
        }
      }
    } catch (error) {
      this.imgURL.push({
        url: upload_fileIcon + "no_preview.jpg",
        size: file.size,
        type: "image",
        name: file.name,
      });
      this.fileUpload.push(file);
      this.fileUploadCount = this.fileUpload.length;

      if (num + 1 == file_length) {
        this.file_upload_loader = false;
      }
      this.pasteEvnetStatus = true;
    }
  }
  editIqrid = this.route.snapshot.params["id"];

  addMediaPost(mediaPostArr, type) {
    this.btnLoader = true;
    this.totalMediaSize = 0;
    this.totalMediaLength = 0;
    this.fileUploadLoader = true;
    this.imgURL = [];
    this.videoURL = [];
    let frmData = new FormData();
    frmData.append("InquiryId", this.id);
    for (const file of this.fileUpload) {
      frmData.append("file[]", file);
    }

    switch (type) {
      case "Inquiry Received Copy":
        frmData.append("Type", "InquiryReceivedCopy");
        break;
      case "Quotation Sent Copy":
        frmData.append("Type", "QuotationSentCopy");
        break;
      case "Technical Data Sheets with Product Image":
        frmData.append("Type", "ProductImage");
        break;
      case "Factory Backup Documents":
        frmData.append("Type", "FactoryBackupDocuments");
        break;
      case "Costing Sheet":
        frmData.append("Type", "CostingSheet");
        break;
      case "Other 1":
        frmData.append("Type", "Other1");
        break;
      case "Other 2":
        frmData.append("Type", "Other2");
        break;
      default:
        break;
    }
    this.UserService.ImportInquiryDocument(frmData).subscribe(
      (res) => {
        this.fileUploadLoader = false;
        if (res?.["result"] == "success") {
          this.toastr.success(res["Msg"], "Success!");
          this.fileUploadCount = 0;
          this.fileUploadLoader = false;
          this.fileUpload = [];
          this.btnLoader = false;
          this.closeModalFileUplaodFalse();
          this.getInquiryDetails();
          this.modalRef.hide();
        } else {
          this.toastr.error(res["Msg"], "Error!");
          this.btnLoader = false;
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        this.fileUploadLoader = false;
        this.btnLoader = false;
        if (err?.error?.result === "failed" && err?.error?.Msg) {
          this.toastr.error(err["error"]["Msg"], "Error!");
          localStorage.removeItem("token");
          this.router.navigate(["/inquiry/editinquiry/" + this.editIqrid]);
        } else if (err?.Msg) {
          this.toastr.error(
            "File not uploaded. You may have slow internet speed or uploaded media size is too large.",
            "Error!"
          );
        }
      }
    );
    this.clicked = false;
  }

  deleteOpenModal(template: TemplateRef<any>, name, data) {
    if (data) {
      this.inqId = data.InquiryId;
      this.filename = name;
      this.file = data[name];
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  deleteConfirm() {
    this.deletefileinfo();
    this.modalRef.hide();
  }

  deletefileinfo() {
    this.spinner.show();
    this.delNameDel = true;
    let Data = {
      FileName: this.filename,
      InquiryId: this.inqId,
    };
    this.UserService.DeleteInquiryAttachment(Data).subscribe(
      (res) => {
        this.delNameDel = false;
        if (res?.["result"] === "success") {
          this.spinner.hide();
          this.getInquiryDetails();
          this.toastr.success(res["Msg"], "Success!");
          this.modalRef.hide();
        }
      },
      (err) => {
        this.delNameDel = false;
        if (err?.Msg) {
          this.toastr.error(err["message"], "Error!");
        }
      }
    );
  }

  downloadModal(template: TemplateRef<any>, name, data) {
    if (data) {
      this.filename = name;
      this.file = data;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  downloadConfirm() {
    this.download();
    this.modalRef.hide();
  }

  decline() {
    this.modalRef.hide();
  }

  download(): any {
    window.open(this.file);
  }

  openClosefun() {
    this.isCollapsed = !this.isCollapsed;
  }
}
